/**
 * Sprint 4X.2 — Modal read-only per visualizzare un'anagrafica dal pulsante occhio.
 * Riusa AnagraficaDatiForm con readOnly=true.
 */
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import AnagraficaDatiForm from "@/components/anagrafiche/AnagraficaDatiForm";

export default function AnagraficaViewModal({ open, onOpenChange, anagraficaId }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [taxonomy, setTaxonomy] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !anagraficaId) return;
    setLoading(true);
    Promise.all([
      api.get(`/anagrafiche/${anagraficaId}`),
      api.get(`/anagrafiche/_meta`).catch(() => ({ data: { taxonomy: {} } })),
    ])
      .then(([r, m]) => {
        setData(r.data);
        setTaxonomy(m.data?.taxonomy || {});
      })
      .finally(() => setLoading(false));
  }, [open, anagraficaId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="anag-view-modal">
        <DialogHeader>
          <DialogTitle>Visualizza anagrafica</DialogTitle>
        </DialogHeader>
        {loading && <div className="text-sm text-slate-500 py-6 text-center">Caricamento...</div>}
        {!loading && data && (
          <AnagraficaDatiForm
            value={data}
            onChange={() => {}}
            taxonomy={taxonomy}
            mode="edit"
            hideAccessSection
            readOnly
          />
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="anag-view-close">Chiudi</Button>
          <Button
            className="bg-blue-600 hover:bg-blue-700"
            onClick={() => { onOpenChange(false); navigate(`/anagrafiche/${anagraficaId}`); }}
            data-testid="anag-view-open-full"
          >
            Apri scheda completa
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
